import { useMemo } from 'react'
import { useAllTransactions } from 'state/transactions/hooks'
import { TransactionType } from 'state/transactions/types'

export function useHasRecentPositionTransactions(): boolean {
  const allTransactions = useAllTransactions()

  return useMemo(() => {
    const fiveMinutesAgo = new Date().getTime() - 5 * 60 * 1000

    return Object.values(allTransactions).some((tx) => {
      if (tx.addedTime < fiveMinutesAgo) return false

      const relevantTypes = [
        TransactionType.ADD_LIQUIDITY_V3_POOL,
        TransactionType.REMOVE_LIQUIDITY_V3,
        TransactionType.ADD_LIQUIDITY_V2_POOL,
        TransactionType.REMOVE_LIQUIDITY_V2,
      ]

      return relevantTypes.includes(tx.info.type)
    })
  }, [allTransactions])
}
